import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { createStatus, getStatus, updateStatus } from "../services/statusApi";
import FormField from "../../../Components/Common/Form/FormField";

const AddEditStatusForm = ({ modal, setModal, toggle, selectedStatus }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const { isLoading: isLoadingStatus, isError: isErrorStatus, error: errorStatus, data: Status } = useQuery("Status", getStatus);
  console.log('status ', Status)

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Oups!!! Veuillez renseigner le nom"),
    type: Yup.string().required('Veuillez renseigner le type de ce statut'),
    description: Yup.string().required("Une description serait idéale pour se retrouvée.")
  });

  const initialValues = selectedStatus ? {
    name: selectedStatus.name,
    type: selectedStatus.type,
    description: selectedStatus.description
  } : {
    name: "",
    customStatus: "",
    type: "",
    description: ""
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoadingSubmit(true);
      try {
        if (values.customStatus) {
          values.type = values.customStatus;
        }
        
        if (selectedStatus) {
          await updateStatus(selectedStatus?.id, { ...values });
          toast.success("Le status a été modifié avec succès 🎉");
        } else {
          await createStatus({ ...values });
          toast.success("Le status a été créé avec succès ✅");
        }

        await queryClient.invalidateQueries("Status");
        toggle();
        formik.resetForm();
      } catch (error) {
        if (selectedStatus) {
          console.error("Erreur modification catalogue :", error?.message || error);
          toast.error("😌 Erreur lors de la modification du catalogue :", error?.message || error);
        } else {
          console.error("Erreur lors de l'ajout du catalogue :", error?.message || error);
          toast.error("😌 Erreur lors de l'ajout du catalogue :", error?.message || error);
        }
      } finally {
        setIsLoadingSubmit(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedStatus]);

  const handleTypeChange = (selectedOption) => {
    if (selectedOption.value === 'autre') {
      formik.setFieldValue('type', 'autre');
      formik.setFieldValue('customStatus', '');
    } else {
      formik.setFieldValue('type', selectedOption.value);
      formik.setFieldValue('customStatus', '');
    }
  };

  const typeOptions = (Status && Array.isArray(Status)) 
    ? Status
        .map((type) => type.type)
        .filter((value, index, self) => self.indexOf(value) === index)
        .map((type) => ({
          value: type,
          label: type?.charAt(0).toUpperCase() + type?.slice(1)
        }))
    : [];

  const typeOptionsWithOther = [
    ...typeOptions,
    { value: 'autre', label: 'Autre' }
  ];

  const modalTitle = selectedStatus ? "Édition" : "Ajout";

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "700px" }}
    >
      <ModalHeader toggle={toggle}>
        <div className="text-center"style={{color:'#252525',fontFamily:'Raleway',fontSize:'22px',fontWeight:'bold'}}> 
          {modalTitle} d'un status <CheckCircleOutlined />
        </div>
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row>
            <FormField label="Nom" name="name" formik={formik} colSize={12} placeholder="Entrez le nom du statut ou autres"/>
            <div className="mb-3">
              <label htmlFor="type" className="form-label">Type</label>
              <Select
                id="type"
                name="type"
                options={typeOptionsWithOther}
                onChange={handleTypeChange}
                value={typeOptionsWithOther.find(option => option.value === formik.values.type) || null}
                placeholder="Commences à écrire pour choisir un catégory"
                isClearable
                isSearchable
              />
            </div>

            {formik.values.type === 'autre' && (
              <FormField label="Autre type à saisir" name="customStatus" formik={formik} placeholder="Entrez un type personnalisé"/>
            )}
            
            <FormField label="Description" name="description" formik={formik} colSize={12} placeholder="Entrez la description du catalogue" isTextarea={true}/>
          </Row>
        </ModalBody>
        <ModalFooter>
        <div className="d-flex justify-content-end gap-2 mt-3">
          <Button className="bordered-btn" color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>
          <Button type="submit" className="bordered-btn dark" disabled={isLoadingSubmit}>
            {isLoadingSubmit ? <Spin size="small" text="En cours" /> : (selectedStatus ? "Modifier" : "Ajouter")}
          </Button>
        </div>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddEditStatusForm;
